// src/components/UserRow.js
import React from 'react';
import { TableRow, TableCell, IconButton } from '@mui/material';
import { AdminPanelSettings as AdminIcon, 
          Delete as DeactivateIcon, 
          ElectricCar as ElectricCarIcon,
          LocalParking as ParkingIcon
        } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

function UserRow({ user, onToggleAdmin, onToggleCanBook, onDeactivate, onToggleElectricCar, currentUserId }) {
  return (
    <TableRow key={user.id}>
      <TableCell>{user.email}</TableCell>
      <TableCell align="center">
        {user.id !== currentUserId && (
          <Tooltip title="Toggle Admin Status" arrow>
            <IconButton
              sx={{
                color: user.is_admin ? 'success.main' : 'grey.300', 
              }}
              onClick={() => onToggleAdmin(user.id)}
              aria-label="Toggle Admin Status"
            >
              <AdminIcon />
            </IconButton>
          </Tooltip>
        )}
      </TableCell>
      <TableCell align="center">
        {user.id !== currentUserId && (
          <Tooltip title="Toggle Can Book" arrow>
            <IconButton
              sx={{
                color: user.can_book ? 'success.main' : 'grey.300', 
              }}
              onClick={() => onToggleCanBook(user.id)}
              aria-label="Toggle Admin Status"
            >
              <ParkingIcon />
            </IconButton>
          </Tooltip>
        )}
      </TableCell>
      <TableCell align="center">
        <Tooltip title="Toggle Electric Car" arrow>
          <IconButton
            sx={{
              color: user.has_electric_car ? 'primary.main' : 'grey.300', 
            }}
            onClick={() => onToggleElectricCar(user.id, user.has_electric_car)}
            aria-label="Toggle Electric Car Status"
          >
            <ElectricCarIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell align="center">
        <Tooltip title="Deactivate User" arrow>
          <IconButton
            sx={{
              color: 'error.main', 
            }}
            onClick={() => onDeactivate(user.id)}
            aria-label="Deactivate User"
          >
            <DeactivateIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

export default UserRow;
